import { Injectable } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class MenuService {
    constructor(){}

    private dataSubject: ReplaySubject<MenuAction> = new ReplaySubject<MenuAction>(1);

    setData(data: MenuAction): void {
        this.dataSubject.next(data);
    }

    getData$(): Observable<MenuAction> {
        return this.dataSubject.asObservable();
    }
}

/*

    What we want is some mechanism for lower-level components to be
    able to negotiate with the menu exactly which items can be
    shown/enabled

    And also a mechanism for dealing with events -- although that could
    theoretically be handled by the app.component, since most actions
    will either be of the form 'navigate to xx' or 'perform immediate action "y"'

    So is this a command-style interface?

        setData( new MenuAction(.Disable, id) );
        setData( new MenuAction(.Hide, id) );
        setData( new MenuAction(.ChangeText, id, "new name") );

    Does that seem reasonable?

 */

export enum MenuActionType {
    DisableOption,
    HideOption,
    ChangeOptionText,
    HideAll,
    ShowAll,
    Refresh,
}

export class MenuAction {
    actionType: MenuActionType;
    constructor(t: MenuActionType, id?: string, text?: string) {
        this.actionType = t;
    }
}